import { createAction } from "typesafe-actions";
import { domain } from "./types.js";
const setRequestStatus = `${domain}/setRequestStatus`;
const setErrorMessage = `${domain}/setErrorMessage`;
const setSuccessResponse = `${domain}/setSuccessResponse`;
const clearAsyncActionsState = `${domain}/clearAsyncActionsState`;
const unuseAsyncAction = `${domain}/unuseAsyncAction`;
const asyncActions = {
  setRequestStatus: createAction(setRequestStatus)(),
  setErrorMessage: createAction(setErrorMessage)(),
  setSuccessResponse: createAction(setSuccessResponse)(),
  unuseAsyncAction: createAction(unuseAsyncAction)(),
  clearAsyncActionsState: createAction(clearAsyncActionsState)()
};
export {
  asyncActions
};
//# sourceMappingURL=actions.js.map
